import { useApolloClient } from "@apollo/client";
import { useSearchParams } from "solito/navigation";
import GetPhotoForFullPublicPhotoDocument from "src/api/graphql/__generated__/documents/GetPhotoForFullPublicPhotoDocument";
import useMountEffect from "src/hooks/useMountEffect";
import { useModal } from "src/modals";
import PublicGatheringModal from "src/modals/configs/PublicGatheringModal";

const GatheringPublicFullPresentPhotoDetail = ({ gatheringId }: { gatheringId: string }) => {
	const search = useSearchParams<{
		photo?: string;
	}>();
	const { presentModal } = useModal<PublicGatheringModal>();
	const apolloClient = useApolloClient();
	useMountEffect(() => {
		const photoId = search?.get("photo");
		if (photoId && photoId.length === 36) {
			(async () => {
				const { data } = await apolloClient.query({
					query: GetPhotoForFullPublicPhotoDocument,
					variables: {
						input: {
							photoId,
						},
					},
				});
				if (data.getPhoto) {
					presentModal("PhotoPublicPreviewModal", {
						props: {
							photo: data.getPhoto,
							gatheringId,
						},
					});
				}
			})();
		}
	}, []);

	return <></>;
};
export default GatheringPublicFullPresentPhotoDetail;
